import styled, { createGlobalStyle } from 'styled-components';

export const AppWrapper = styled.div`
  background-image: url('/images/background.png');
  background-size: cover;
  background-position: center;
  display: flex;
  min-height: 100vh;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 2rem;
  padding-top: calc(48px + 1.5rem); /* clear the fixed 48px header */
  background-color: ${(props) => props.theme.contentBackground};
  margin-left: ${(props) => (props.isSidebarOpen ? '250px' : '60px')};
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin-left: 0; /* sidebar overlays on mobile */
    padding: 1rem;
    padding-top: calc(48px + 0.75rem);
    width: 100%;
  }
`;

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
    padding: 0; 
    overflow-x: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  }

  body {
    font-size: 1rem;
  }

  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
